// extracted by mini-css-extract-plugin
module.exports = {"text":"CommonNotification_text_2FK3A","title":"CommonNotification_title_2Ou-L","container":"CommonNotification_container_2GtRS"};